<template>
  <div>
    <el-card class="box-card">
      <el-form :inline="true">
        <el-form-item label="充值时间" span="2">
          <el-date-picker
            clearable
            v-model="query.leftRechargeDate"
            type="date"
            placeholder="开始日期">
          </el-date-picker>
          -
          <el-date-picker
            clearable
            style="margin-right: 15px;"
            v-model="query.rightRechargeDate"
            type="date"
            placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.tradeStatus" clearable placeholder="请选择" style='width: 200px;'>
            <el-option v-for="(item, index) in $key.myAccount.tradeStatus" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 20px;" >
          <el-button type="primary" @click="handleSearch"><i class="fa fa-search"> 查询</i>
          </el-button>
          <el-button type="primary" plain @click="handleReset"><i class="fa fa-refresh"> 重置</i>
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <!-- 导出 -->
    <inquery-result style="margin-bottom: 20px;" :isExport='false'></inquery-result>
    <z-table
      :current-page.sync="currentPage"
      :total="total"
      @current-change="changePage"
      @sort="changeSort"
    >
      <el-table
        :data="tableData"
        ref="zTable"
      >
        <el-table-column
          align="center"
          prop="applyCode"
          label="流水号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="applyDate"
          label="充值时间">
        </el-table-column>
        <el-table-column
          align="center"
          prop="rechargeAmount"
          label="充值金额(元)">
          <template slot-scope="scope">
            <span>
              {{scope.row.rechargeAmount | thousandMark}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="availableAmount"
          label="余额(元)">
          <template slot-scope="scope">
            <span>
              {{scope.row.availableAmount | thousandMark}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="rechargeBank"
          label="银行名称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="bankOrderNo"
          label="银行流水号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="tradeStatus"
          label="状态">
          <template slot-scope="scope">{{ scope.row.tradeStatus | keyFilter("myAccount", "tradeStatus") }}</template>
        </el-table-column>
      </el-table>
    </z-table>
    <handle-create v-if="rechargeDialogVisible" :rechargeDialogVisible="rechargeDialogVisible" @toggleHandleCreate="toggleHandleCreate"></handle-create>
  </div>
</template>

<script>
import HandleCreate from './jd-enterprise-top-up'
import api from '@/api'
import { formatTime } from '@/utils/util'

function Query () {
  this.tradeStatus = ''
  this.leftRechargeDate = ''
  this.rightRechargeDate = ''
}

export default {
  name: 'records',
  components: {
    HandleCreate
  },
  data () {
    return {
      rechargeDialogVisible: false,
      advanced: false,

      query: new Query(),

      currentPage: 1,
      total: 0,
      pageSize: 10,

      tableData: []
    }
  },

  mounted () {
    this.fetchList(1)
  },
  methods: {
    async fetchList (currentNo, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentNo = currentNo || this.currentNo || 1
      let param = {
        ...this.query,
        marketId: '10102',
        bankCode: 'JDFC',
        currentNo: this.currentNo,
        pageSize: this.pageSize
      }
      param.leftRechargeDate = formatTime(this, this.query.leftRechargeDate)
      param.rightRechargeDate = formatTime(this, this.query.rightRechargeDate, 1)

      let res = await api.myAccount.fetchList(param)
      this.tableData = res.data.rows
      this.total = res.data.totalElements
    },
    toAdd () {
      // 个人用户屏蔽充值功能 mchtType01企业   mchtType02个人
      if (this.$ls.get('USER_INFO').userType === 'mchtType02') {
        this.$message.error('非企业用户不能进行充值')
        return
      }
      this.toggleHandleCreate(true)
    },
    toggleHandleCreate (flag) {
      this.rechargeDialogVisible = flag
    },
    handleSearch () {
      this.fetchList(1)
    },
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    changePage (page) {
      this.fetchList(page)
    },
    changeSort (prop) {
      console.log('重新获取表格内容，页数为第一页，排序为prop')
    }
  }
}
</script>

<style lang="scss" scoped>
.adsf {
  background: red;
  color: #fff;
  height: 50px;
  line-height: 50px;
}
::v-deep .table-page-search-submitButtons{
  margin-left: 100px
}
</style>
